import {GET_VACATION_HOUR_LIST, GET_CURRENT_VACATION_HOUR_LIST} from '../actionTypes'
import{getAxiosInstance} from '../utils/axios-api';
import {getAccessToken} from '../utils/customMethods';
import { notify } from '../utils/notifications/notifications';

export const currentVacationHrs=()=>async dispatch =>{    
    try{
        const response = await getAxiosInstance().get(
            `/currentVacationHrs?access_token=${getAccessToken()}`           
        );    
        dispatch({
            type: GET_CURRENT_VACATION_HOUR_LIST,
            payload: (response.data.data||[]).map(item=>{
                return {...item, empName:item.empLName+', '+item.empFName}
            })
        });
    }catch(ex){
        dispatch({
            type: GET_CURRENT_VACATION_HOUR_LIST,
            payload: undefined
        });
    }
}
export const vacationHourFileUpload = (file) => async dispatch => {
    try{
                if((file || '') === ''){
                    notify('error',"Please upload file");
                    return false;
                }
                const formData = new FormData();
                formData.append('file',file)
                const response = await getAxiosInstance().put(
                    `/fileUpload?access_token=${getAccessToken()}`, formData      
                );
                if(response.status===200){
                    //notify('success',"File uploaded successfully");
                    dispatch({
                        type: GET_VACATION_HOUR_LIST,
                        payload: response.data.data||undefined
                    });  
                    return true;            
                }
                else{
                    notify('error',"File upload failed");
                    dispatch({
                        type: GET_VACATION_HOUR_LIST,
                        payload: undefined
                    });
                    return false
                }
        }catch(ex){
            notify('error',"Something went wrong. Please try again");
            return false;
        }
};
export const userHoursUpdate=(hours)=> async dispatch => {
    try{
        if(hours.length > 0){
            const response = await getAxiosInstance().put(
                `/usrHoursUpdate?access_token=${getAccessToken()}`,hours      
            );
            if(response.status===200){
                notify('success',"Hours updated successfully");  
                return true;            
            }
            else{
                notify('error',"Hours update failed");
                return false
            }
        }else{
            return false;
        }
    }catch(ex){
        return false
    }
}
